;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface GradientBorderLayoutProps extends React.ComponentProps<"section"> {
	beforeElement?: React.ReactNode;
	afterElement?: React.ReactNode;
	contentClassName?: string;
}

export function GradientPseudoElement({
	className,
	...props
}: React.ComponentProps<"div">) {
	return (
		<div
			className={cn(
				"rounded-(--inner-radius) bg-white bg-blend-color backdrop-blur-sm border border-white/30 p-4 relative z-1",
				"data-before:rounded-b-none data-before:pb-5 data-before:-mb-2 data-before:shadow-[0px_0px_16px_8px_rgba(31,38,135,0.07)] data-before:border-b-gray-200",
				"data-after:rounded-t-none data-after:pt-3.5 data-after:shadow-[5px_8px_16px_16px_rgba(31,38,135,0.07)] data-after:border-t-gray-200",
				className,
			)}
			data-slot="gradient-pseudo-element"
			{...props}
		/>
	);
}

export function GradientBorderLayout({
	children,
	className,
	contentClassName,
	beforeElement,
	afterElement,
	...sectionProps
}: GradientBorderLayoutProps) {
	return (
		<section
			{...sectionProps}
			className={cn(
				// Base
				"relative z-10 container mx-auto sm:py-16 max-w-md",
				// Define variables for the gradient border
				"[--p:--spacing(2)] sm:[--p:--spacing(4)]",
				"[--card-radius:calc(var(--radius)+var(--p))]",
				"[--inner-radius:calc(var(--card-radius)-calc(var(--p)*calc(1/2)))]",
				className,
			)}
		>
			<div
				className={cn(
					"p-(--p) rounded-(--card-radius)",
					"bg-linear-to-br from-sidebar/50 to-sidebar-accent/50",
				)}
			>
				{beforeElement && (
					<GradientPseudoElement data-before>
						{beforeElement}
					</GradientPseudoElement>
				)}
				<Card
					className={cn(
						"relative z-2 rounded-(--inner-radius)",
						"shadow-xl bg-card/95 backdrop-blur-sm border-0",
						"data-[before=true]:rounded-t-none data-[after=true]:rounded-b-none",
					)}
					data-after={!!afterElement}
					data-before={!!beforeElement}
				>
					<CardContent className={cn("px-4 sm:px-8", contentClassName)}>
						{children}
					</CardContent>
				</Card>
				{afterElement && (
					<GradientPseudoElement data-after>
						{afterElement}
					</GradientPseudoElement>
				)}
			</div>
		</section>
	);
}
